import useSWR from 'swr'
import { useLidoSDK } from './useLidoSDK'
import { formatEther, parseEther } from 'viem'
import { formatFormAmount } from '~/utils/numbers'

export const useStEth2WstEthRate = (amount: string) => {
  const { wrap } = useLidoSDK()
  const formattedAmount = parseEther(amount)
  const { data } = useSWR(
    ['lido-steth-2-wsteth-rate', formattedAmount.toString()],
    async () => {
      if (formattedAmount === 0n) {
        return 0n
      }
      return wrap.convertStethToWsteth(formattedAmount)
    },
    {
      refreshInterval: 60000,
    },
  )

  return !!data ? formatFormAmount(formatEther(data), 6) : '0'
}
